<template>
  <div class="layout-row quantity">
    <div class="font-15-999" @click="change(0)"></div>
    <div class="font-15-333 b">{{ val }}</div>
    <div class="font-15-999" @click="change(1)"></div>
  </div>
</template>

<script>
export default {
  props: ['value', 'max', 'maxToast'],
  data () {
    return { val: 1 }
  },
  created () {
    this.val = this.value
  },
  watch: {
    // 外部（父组件重置/切换规格）改动数量时，同步内部显示，避免与 value 脱节
    value (nv) {
      if (nv !== undefined && nv !== null && nv !== '' && Number(this.val) !== Number(nv)) {
        this.val = Number(nv)
      }
    },
    // 切换规格导致限购上限变小时，自动把数量降到上限
    max (nv) {
      if (nv !== undefined && nv !== null && nv !== '' && Number(this.val) > Number(nv)) {
        this.val = Number(nv)
        this.$emit('change', this.val)
      }
    }
  },
  methods: {
    change (type) {
      if (type === 0) {
        if (this.val > 1) {
          --this.val
          this.$emit('change', this.val)
        } else {
          this.$toast('已经是最小了')
        }
      }
      if (type === 1) {
        // 限购/上限判断：传了 max 才限制；Number + >= 避免字符串比较和漏判
        if (
          this.max !== undefined &&
          this.max !== null &&
          this.max !== '' &&
          Number(this.val) >= Number(this.max)
        ) {
          this.$toast(this.maxToast || '已经是最大了')
        } else {
          ++this.val
          this.$emit('change', this.val)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.quantity {
  div {
    width: 1.65rem;
    text-align: center;
    height: 1.5rem;
    line-height: 1.5rem;
    background: #f5f5f5;
  }
  div:nth-child(1) {
    font-size: 1.25rem;
    border-radius: 2px 0px 0px 2px;
    position: relative;
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      content: " ";
      width: 0.6rem;
      height: 0.1rem;
      background-color: #999;
    }
  }
  div:nth-child(3) {
    font-size: 1.25rem;
    border-radius: 0px 2px 2px 0px;
    position: relative;
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      content: " ";
      width: 0.6rem;
      height: 0.1rem;
      background-color: #999;
    }
    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      content: " ";
      width: 0.1rem;
      height: 0.6rem;
      background-color: #999;
    }
  }
  div:nth-child(2) {
    margin: 0 1px;
    width: 1.9rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputNumber.vue